import React from 'react'
import { useParams } from 'react-router-dom';

const Info = () => {
    const { seriesId } = useParams();

    return (
        <div>{seriesId} Series Info</div>
    )
}
export default Info